var React = require('react');

function Video (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"play-button-r"},[React.createElement("path",{"id":"Path_867","data-name":"Path 867","d":"M21.886,3.765H6.03A2.265,2.265,0,0,0,3.765,6.03V21.886A2.265,2.265,0,0,0,6.03,24.151H21.886a2.265,2.265,0,0,0,2.265-2.265V6.03A2.265,2.265,0,0,0,21.886,3.765ZM6.03,1.5A4.53,4.53,0,0,0,1.5,6.03V21.886a4.53,4.53,0,0,0,4.53,4.53H21.886a4.53,4.53,0,0,0,4.53-4.53V6.03a4.53,4.53,0,0,0-4.53-4.53Z","transform":"translate(0)","fill":"currentColor","fillRule":"evenodd","key":0}),React.createElement("path",{"id":"Path_868","data-name":"Path 868","d":"M21.8,16.409l-6.8,4.9V11.505Z","transform":"translate(-3.307 -2.451)","fill":"currentColor","key":1})]));
}

Video.defaultProps = {"viewBox":"0 0 27 27"};

module.exports = Video;

Video.default = Video;
